import React from 'react';
import { Editor } from 'components';
import Container from "./Container";
import Page from './Page';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  leftColumn: {
    flexGrow: 1,
    paddingRight: '16px',
    boxSizing: 'border-box',
  },
  rightColumn: {
    width: '50%',
    maxWidth: '143mm',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  descriptionTitle: {
    fontWeight: 'bold',
  },
  descriptionContainer: {
    display: 'flex',
    fontSize: '13px',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '16px',
    flexGrow: 1,
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '16px',
    flexGrow: 1,
  },
  editorContainer: {
    marginBottom: '20px',
  },
};

const logoImage =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBIVEhgRERcZEhgYHB0YGBQZGSAcGBkRHBwZHB4ZHhgfIS4lHB4rHxgaJjgmKy8xNTU2Gic7QDs0Py40NTQBDAwMBgYGEAYGEDEdFh0xMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMf/AABEIAOYA2wMBIgACEQEDEQH/xAAcAAEAAgMBAQEAAAAAAAAAAAAABgcBBAUDAgj/xABBEAABAwIBBgoHBwQCAwAAAAABAAIDBBEFBgcSITFBExciMlFhcXKTsTM1UlOBkbIUQmJzobPRI4KSwSRDFmPw/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/ALmREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEUNyty7p6M8E0cPNa5YDZrOjSduP4Rr7FDTnIxN3KjgbonZoxveP8ALeguRFTfGFi3uB4D04wsW9wPAeguRFTfGFi3uB4D04wsW9wPAeguRFTfGFi3uB4D04wsW9wPAeguRFTfGFi3uB4D04wsW9wPAeguRFTfGFi3uB4D04wsW9wPAeguRFTfGFi3uB4D04wsWGswDwJEFx3WVW2Tuc+OR4irWCAk2EjSSy+zlA629uxWM1wIuNYO/qQfaIiAiIgIiICIiAiIgLkZT4p9mo5qm1yxhLR0yGzWj/JwXXUSzoeqp+2L96NBC82mTbap8ldV/wBWzzoh2sPl2uc7psdyt1jAAA0WA1ADUAOxQzNJ6tH5j/MKboMWRZRBhFleckgaCXEADaSbAfFB9oopimX+HQEtMvCOH3YwX6+i41BcZ2dmjvqhnI6bM8tNBYiKFUGcvDpDZznwn/2MIH+QuApdSVkcrA+J7ZGnY5pBH6IPdFzscxeOlgdUSmzWjUN7nbmjrK+cCxqGrhbPA67TqLTzmv3tcNxCDppZFlBBc4mSkU9O+pjaGzRtLrtFtNo2td0m2wryzS4w6akdA86ToHBrSdpicLs+VnD4BTTFfQS9x30lVhmS51V3YfOVBbSIiAiIgIiICIiAiIgKJZ0PVU/bF+9GpaolnQ9VT9sX70aDVzSerR+Y/wAwpuoRmk9Wj8x/mFN0BEXjPM1jHPcQ1rQXOcdgaBcn5IOblHj8NFCZpz1NYOe9+5rR/vcqTx7KasxCQR8rRcbMp47kfEDW89v6LzyhxebEqy7AXaTtCCLoYTq1bnHnOO74K3sjckYqGMEgSTuHLltv9lvstCCvsGzXVcgDqhzKVp+7bTkt1tBDW/M9ikLc0lNbXUzE9IDAPloqykQVDimaaZoLqWdsp9iRugT/AHtuP0CiLJK/DJ7cumeNeidbHgdXNeOxfosqn86uUjJXiii0XCN2k+S1zwm5jTutvQRjKrKqeucwyARtYLBjSS3T+87XvO7oXnknjNVTVLHUoLy8hrod0g9nqPQdy4it7NNgUAg+3XD5XlzNnog02Le8dRv0EILEiJLQXDRJAJF72PRfevVYCyg1MU9BJ3HfSVWGZLnVXdh85VZ+Kegk7jvpKrDMlzqruw+cqC2kREBERAREQEREBERAUSzoeqp+2L96NS1RLOh6qn7Yv3o0Grmk9Wj8x/mFN1CM0nq0fmP8wpugKD51sRMVAY2mxmcGf2jlO/QBThVVnokP/Gbu5Z+OoINXM/hAdLJVvF+DAjZ1OdrJ+VvmreUGzRsAw642uleSeywH6BeWcvK19KxtPTO0Zn8ouGsxxNO23S46hfcHHoQT9FAsjc4UVTowVVoZ9gOyOQ/hJ5rvwn4EqRZT49HRU7p5NZ5rGX1vkOxvZ0noQcHOLlb9ki4CF3/IkBtv4OPYZD17mj47lSJO86+knWSTvJ3nrWziVfJPK+eZ2k950nHd1ADcANQVh5uMidItr6tvJHKhiI5x3SOB3DcPj0IOM/IWRmGvrpbskGi9sXRDfWXD2iDe25dbM3iJbNNSk8l7RI0fjbZrj8Wkf4qzMejDqSdrthjf9JKpbNfIRiUVt7Xg9hagvtFhZQamKegk7jvpKrDMlzqruw+cqs/FPQSdx30lVhmS51V3YfOVBbSIiAiIgIiICIiAiIgKJZ0PVU/bF+9GpaolnQ9VT9sX70aDVzSerR+Y/wAwpuoRmk9Wj8x/mFN0BVtnkpCaeGYDmPLXHoDhq/UKyVyMpsKFVSyU51F7eS72ZBrafmEEOzOVwdTS099cb9MD8DgP9tWxl7kL9qJq6Y2nAGkxx5EjQNQv91wGzd09IrjJXGH0FYHyAtAJjmZvABs7V0tIuv0BTVLJGNkjcHMcAWuGsFpQfmKeF7HuZI0se02cxws5rhuIW1X4pPO1jZ5HSCMaLNI3sP8AZ6z0K8cr8j4K5ulqjmA5EoHya4feb5Kvcmc3dQ+qc2sYY44zyiDqk3gMO9p3lAzc5HGpeKupbaBp/ptP/a8Hb3AdV957FdDG21DUBqA6l8QxNa0MaA1rQGhoFgGjUAB0WXqUHAy5rhDh87ybEsLG9b38kD9VV+aSkL8Q090cbie11mj/AGvbOjlM2olFJC4GOIkvcNjpRqt1huv49imGazA3U9IZ5BoyVBD7Ha2EamA9BIJdb8Q6EE6REQamKegk7jvpKrDMlzqruw+cqs/FPQSdx30lVhmS51V3YfOVBbSIiAiIgIiICIiAiIgKJZ0PVU/bF+9GpaolnQ9VT9sX70aDVzSerR+Y/wAwpuoRmk9Wj8x/mFN0BYWUQVvnHyKM5NZStvKB/UjH/Y0bHD8YGrrA6lCMkssqihcY3AyQ35cLtTmOvrLCea7padR6jrV/WUTynyFpawmTXDL71gGvvN2O8+tBt4LlhQ1IHByta4/9b+Q8f2nb2jUu6JmbdJvzCo7Fc2mIxk8GxlU0bCxwa63ceRr7CVy//GsUHJ+zVI6gDb9HWQXrieP0lO3SnmjZ1aQLj2NGsqrssM4752ugog6KMgh0p1SOb0NH3Gnp29i4tBm/xOU3MHAg7XSva39AXOPyU+yczZ08JElU77S8awy1owe7td8fkgimQORLqh7ampaWwNN2sItwpGwW9jz7Lq62i2pYY0AWAsBqAG4L7QEREGpinoJO476SqwzJc6q7sPnKrPxT0Encd9JVYZkudVd2HzlQW0iIgIiICIiAiIgIiICiWdD1VP2xfvRqWqJZ0PVU/bF+9Gg1c0nq0fmP8wpsSoTmk9Wj8x/mFNigiEucXDWuc1z3XaS0/wBN20Gx8lhucjDCbcI4dZjdZUrUR6dU9hNtKVzb9ALyL/qpXlJkNHS07qhtW2QtIGhYAuubWFnHXvQXJh+IwzxiWB7ZGHY5pvr6D0HqW4qVzR1z21b4tKzHsc94J5Icy1ndANidakeNZ04Y5DHTRGo0TYvLtBhI9nUSR12QWMuJj+U9LRljalxaXgltml1w219naFGcn85tPO9sVQw0rnENa4uDoy46gC6wLSTq1i2tcfPT6Sl7snmxBY2BY3BWRmamcXNDiwktLTpgNJFj1OC1ceyqpKN7WVLnNc9uk0Bpdqvbd1qB5tsqKOlpHxVMgjcZnPDbE8gtYAbgdIK42c3G6eqnifTP4RrGFriARZ2lff1ILhwbGIaqLh4CSy5bci2sbdRXDxHODh0LywyGQjUdBpcAejS2KEUtXJHk44xkt0pnMcRtDHOF9e6+xQzBoqR0hbVyPhZbkvYwOOn0EbhboCC8MLy6w6dwYyXQcdQbIC256ATqUnBVHYZkbS1FRGynrI5oif6jTyJg0a7Bu8nZfcrsp4WsY1jBotaA1o6GgWAQeWKegk7jvpKrDMlzqruw+cqs/FPQSdx30lVhmS51V3YfOVBbSIiAiIgIiICIiAiIgKJZ0PVU/bF+9GpaolnQ9VT9sX70aDVzSerR+Y/zCmxUJzSerR+Y/wAwpsUH5jrYy6oexouXSvAHSS8ga+0r7xbCZ6aTgalnBvsHWuHck7w4Eg7FNeLjEPtPC/0tHhdP0hvoaels0dtlLs4eSUlc2N9PoCRhLTpmwMZ6wDsKCH4NhLYcFqK+N/CSSsLTYW4KMOs9nTpdJ7Fzc2mGU1RWOZVBrw2MuYx3Ne7SANxvs03t133Kb5DZLVlM2amqxG+CVusNeSQ+1jqLRqI8lGsZzX1bHk0jmSsvdoc7Qe3qvax1b9SDg5fYfTQ1z4qawZotLmNNwxxHKaOjdq61184Ur302HPk57oCXE7SSI9Z7dq3sAzXTOeH1zmNYDcxsOk549kutqB37VIc4eSdTWOg+zaAbG1zSHuta+jYAAHc1BBck8hX10Dp2TtiDXuZolhdcta03uHD2loZXZMvoJGRvkbMXtL7tYWWANrWLjdW3m9wKeipHw1GjpGVzxoO0hoFrANZA3tK5OcTJGqrZo30/B6LGFrtNxadIuvuB3IPHIltOcDf9rtwOlIX36LjZ+K+zrUPpskYalpfh1XG7fwFReOZh9lxFwe0C3WVOsOyHkdhf2Cpfwbg9zw6N2k25OrSBA0h1KGV2a/EGuswRTN3O0tE/4kavmgi+I0MtNMY3loeyx0mPDgDtBDxsPyKv/JGtfPQwTSa3PYC49JGq/wAbKs8HzWVTnj7U5kLAeUGHScR0DUAO1W/R07I42xRjRaxoa0dAGpB8Yp6CTuO+kqsMyXOqu7D5yqz8U9BJ3HfSVWGZLnVXdh85UFtIiICIiAiIgIiICIiAolnQ9VT9sX70alqiecxhdhVRbdwbj3Wyxkn5AlBqZpPVo/Mf5hTYqCZopmnDywHWyR+kOi9iFO0EDOL4lWVVRFh74qaOmdwZc9um58tr2tuH/wBdfWJY9iLBTUYbEysqC4F2t0TGMvd9ukgXt5r3rclKplTLU4dVCm4fXLG+PTaX+23WLHWfntWa3I2R8MGjUyfaacl0dU8BxJdtaW35vx+aDXpsar6erFFXPjn4WN74Z2M0CHsGtrm7D+i4OCZwan7PUmqLXSBjX0pDA0PcXGPRsOdZ+ifn0KT4dkpOZzV11QKmYMdHGGM0I42uFiQ25udfUtKhzetY2jEkjXupXyOcQwgSRvcZGssXarOsb696Di/+Y4gMN4dz2NlFSIS4xjRay2u7eo6/gtuiyurBJUQOngq9CndMyoiZZrHt2McL2K3pcgnupnU5mZyqo1JOgbaJcSWWvt12upNWYFEaeWCnYyAytLS5rABc7CQLXQaGH4vM/B21jnDhTTmQu0RbhNEm+jstfcuPWZU1IwqlmYWuqqoxsZyNWm9w0jobLW1fFbGFZLYhFAaSSrjkg4F8TWCEtLSW2a7S0iSBfYvB2QD3ilimqCI6WPQAjBa90u3TDiSG67bidSDNPlTUOwmoncWtqaYvjkOiLCRr7X0dliFymZf1D6WEXbHUtnjjnaWDlwv1h7Wnm3BHYeohdMZv3sZVQxVF46lgbaRpc9sgN9MuBGlv3Ar1xjIBsxppGPayWBsbJH6BLZWRhttV9TtWo69Rsb2CDVx/EMXiroaWOeENqXPEd4b6DWgkBxvytQ3Ke0LZBGwTOD3ho03NFml+8gbguLjGT7p62lqw8MFMXEsLSS7SFtTr6vkpEEGrinoJO476SqwzJc6q7sPnKrKxuZrKaZzzZojfc/2lVxmTjP8AynW1f0m3/EOEJHycPmgtdERAREQEREBERAREQFrVtMyWN8Ug0mPaWOb0tcLEfIrZRBR0E1VgdY5j2mWJ+oX1NlYNha7YJANo/wBKcQZzsOc0FxkYd7Swmx7QbFS+toopmGOZjZWna1wBHyKjUubrDHG/BOb1NkeB8BdB48ZmGe3J4blnjLwz23+G5ffFvhnu3+I7+U4tsM92/wAR38oPPjMwz25PDcs8ZmGe3J4bl98W+Ge7f4jv5Ti2wz3b/Ed/KD44y8M9t/huWOMzDPbk8Ny9OLfDPdv8R38pxbYZ7t/iO/lB8cZeGe2/w3LHGZhntyeG5enFvhnu3+I7+U4tsM92/wAR38oPPjMwz25PDcs8ZmGe3J4bl98W+Ge7f4jv5Ti3wz3b/Ed/KD44y8M9t/huWDnMw325PDK9OLfDPdv8R38oM2+Ge7f4j/5QQfKrLOXES2hoo3hjzrb9+S26w5rOn9VY+ReT4oaRsJIc9x05HDYZDuHUAAB2LewnAqWmBFNE2O+0gco9rjrK6iAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIiICIiD//Z';

class Template extends React.Component {
  constructor(props) {
    super(props);
    this.tmplRef = React.createRef();
  }

  render() {
    const { changeContent, product, content, removableArea: RemovableArea } = this.props;

    return (
      <Container containerRef={this.props.containerRef}>
        <Page
          removableArea={RemovableArea}
          product={product}
          pageRef={this.tmplRef}
        >
          <div style={styles.container}>
            <div style={styles.leftColumn}>
              <Editor
                content={content?.section1}
                setContent={(value) => changeContent('section1', value)}
              />
            </div>
            <div style={styles.rightColumn}>
              {product.imageUrl && (
                <RemovableArea data-removable id="image" style={styles.image}>
                  <img src={product.imageUrl} />
                </RemovableArea>
              )}
              <RemovableArea data-removable id="logo" style={styles.logo}>
                <img src={logoImage} width="100" />
              </RemovableArea>
            </div>
          </div>
          <RemovableArea
            style={styles.descriptionContainer}
            data-removable
            id="description"
          >
            <div>
              <p>
                <span style={styles.descriptionTitle}>DESCRIPTION</span>
              </p>
            </div>
            <div>{product.description}</div>
          </RemovableArea>
          <Editor
            content={content?.section5}
            setContent={(value) => changeContent('section5', value)}
            style={styles.editorContainer}
          />
          <Editor
            content={content?.section6}
            setContent={(value) => changeContent('section6', value)}
            style={styles.editorContainer}
          />
          <Editor
            content={content?.section7}
            setContent={(value) => changeContent('section7', value)}
          />
        </Page>
      </Container>
    );
  }
}

export default Template;
